import { Component, EventEmitter, Input, OnInit, Output, ViewChild, inject } from '@angular/core';
import {getYardIndex, selectProperWheelYardLine} from "../../helpers/distance";
import {WheelSelectorChangeEvent, WheelSelectorComponent} from "../wheel-selector/wheel-selector.component";
import {GameService} from "../../services/game.service";

@Component({
    selector: 'app-select-yard-line',
    templateUrl: './select-yard-line.component.html',
    styleUrls: ['./select-yard-line.component.scss'],
    imports: [WheelSelectorComponent]
})
export class SelectYardLineComponent  implements OnInit {
  private game = inject(GameService);

  startIndex = 0
  data!: any[]
  @Input() public homeHasPossession = true

  @ViewChild('wheelSelector', { static: true }) wheelSelector!: WheelSelectorComponent;

  private _currentYard = ''

  @Input()
  public get currentYard() {
    return this._currentYard
  }

  public set currentYard(yardLine : string) {
    this._currentYard = yardLine
    const yardIndex = getYardIndex(yardLine);
    if (yardIndex < 0) {
      throw new Error(`SelectYardLineComponent.currentYard : yardLine "${yardLine}" non trouvé dans getYardIndex()`)
    }
    this.setYardLineIndex(yardIndex)
  }

  @Output() yardLineChange = new EventEmitter<string>();
  @Input() titlePrefix = ''

  // Pour afficher le nom des équipes
  @Input() homeTeamName = ''
  @Input() awayTeamName = ''

  @Input() disabled = false

  // Type d'affichage des yardLine
  @Input() yardLinesToDisplay: ('default'|'safety'|'inversed'|'simple'|'td-simple') = 'default'

  // Pour mettre à jour directement le yardLine du pending gamePlay
  // sans passer par l'exécution des commandes
  @Input() updateCurrentYard = false

  ngOnInit() {
    this.init();
  }

  public init() {
    this.startIndex = getYardIndex(this.currentYard)
    this.data = [{
      list: selectProperWheelYardLine(this.yardLinesToDisplay), // , Boolean(this.homeTeamName)
      currentIndex: this.startIndex,
      text: 'yard'
    }]
  }

  change (obj: WheelSelectorChangeEvent) {
    this.yardLineChange.emit(obj.value);
    if (this.updateCurrentYard) {
      this.game.getFirstPendingGamePlay().yardLine = obj.value
    }
  }

  setYardLineIndex(index: number) {
    console.debug('setYardLine', this.wheelSelector)
    this.wheelSelector.currentIndexList[0] = index
  }
}
